import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import {
  AdditionalTopicScores,
  NuclearTopicsDistrEnriched,
  Topic,
  WordCloudData,
} from '../../models/ai-model';
import { LabelService } from '../../services/label.service';
import { FormsModule } from '@angular/forms';
import { InterviewAiAppSummComponent } from './interview-ai-sections/interview-ai-appsumm/interview-ai-appsumm.component';
import { InterviewAiNuclearTopicComponent } from './interview-ai-sections/interview-ai-nuclear-topic/interview-ai-nuclear-topic.component';
import { InterviewAiWordcloudComponent } from './interview-ai-sections/interview-ai-wordcloud/interview-ai-wordcloud.component';
import { InterviewAiAiTopicComponent } from './interview-ai-sections/interview-ai-ai-topic/interview-ai-ai-topic.component';

@Component({
  selector: 'app-interview-ai-topic',
  standalone: true,
  imports: [
    SharedModule,
    FormsModule,
    InterviewAiAppSummComponent,
    InterviewAiNuclearTopicComponent,
    InterviewAiWordcloudComponent,
    InterviewAiAiTopicComponent,
  ],
  templateUrl: './interview-ai-topic.component.html',
  styleUrl: './interview-ai-topic.component.scss',
})
export class InterviewAiTopicComponent {
  @Input() appSumm: string = '';
  @Input() isEditing: boolean = false;
  @Output() appSummChange = new EventEmitter<string>();
  @Input() aiWordcloudsSelected: string = 'ai-section-not-selected';
  @Input() aiSummarySelected: string = 'ai-section-not-selected';
  @Input() aiCategoriesDistributionSelected: string = 'ai-section-not-selected';
  @Input() aiTopicSelected: string = 'ai-section-not-selected';
  @Input() nuclearTopicsDistrEnriched: NuclearTopicsDistrEnriched = {
    date: '',
    title: '',
    categories_distribution_available: false,
    categories_distribution: null,
  };
  @Input() topicsForWordclouds: Topic[] = [];
  @Input() wordCloudData: WordCloudData[] = [];
  @Input() isLoadingAiTopic: boolean = true;
  @Input() isLoadingAiWordclouds: boolean = true;
  @Input() isLoadingAiCategoriesDistribution: boolean = true;
  @Input() isLoadingAiSummary: boolean = true;
  @Output() deleteTopic = new EventEmitter<AdditionalTopicScores>();

  constructor(public labelService: LabelService) {}

  onSummaryChange(newSummary: string): void {
    this.appSumm = newSummary;
    this.appSummChange.emit(newSummary);
  }
}
